import { useQuery, QueryFunction } from 'react-query';
import { getAllMachineTypes, GetMachinesTypesQueries, MachineType } from '../../services/apiSLTP/materials/machinesTypes';

type useMachineTypesQueryOptions = {
    queries?: GetMachinesTypesQueries;
};

const getMachineTypes: QueryFunction<MachineType[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, useMachineTypesQueryOptions];
    const { queries } = options;

    const response = await getAllMachineTypes(queries);
    return response.data;
};

export const useMachineTypesQuery = (options: useMachineTypesQueryOptions) => {
    return useQuery(['machineTypes', options], getMachineTypes);
};
